import { createSlice } from "@reduxjs/toolkit";
import {
  AddAccessAction,
  DeleteAccessAction,
  GetAllAccessAction,
  UpdateAccessAction,
} from "store/middlewares/membersAndRoles/permission";

export const accessSlice = createSlice({
  name: "access",
  initialState: {
    accessLoading: true,
    access: null,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(GetAllAccessAction.pending, (state) => {
        // state.accessLoading = true;
        // state.access = null;
        state.access = state.access?.data?.length > 0 ? state.access : null;
      })
      .addCase(GetAllAccessAction.fulfilled, (state, action) => {
        state.accessLoading = false;
        state.access = action.payload.response;
      })
      .addCase(GetAllAccessAction.rejected, (state) => {
        state.accessLoading = false;
        state.access = null;
      })
      // Delete
      .addCase(DeleteAccessAction.fulfilled, (state, action) => {
        state.accessLoading = false;
        // state.access = {
        //   ...state.access,
        //   data: state.access?.data?.filter(
        //     (item) => item.id !== action.payload.id
        //   ),
        // };
        state.accessLoading = false;
        state.access = action.payload.response;
      })
      //Update
      .addCase(UpdateAccessAction.fulfilled, (state, action) => {
        state.accessLoading = false;
        state.access = {
          ...state.access,
          data: state.access.data.map((item) =>
            item.id === action.payload.response.id
              ? action.payload.response
              : item
          ),
        };
      })
      //Add
      .addCase(AddAccessAction.fulfilled, (state, action) => {
        state.accessLoading = false;
        state.access = {
          ...state.access,
          total: Number(state.access.total) + 1,
          data: [action.payload.response, ...state.access.data],
        };
      });
  },
});

export default accessSlice.reducer;
